import Vue from 'vue'
import Router from 'vue-router'
import home from '@/src/index'
import Staff_management from '@/src/Staff_management/index.vue'
import Customer_management from '@/src/Customer_management/index.vue'
import Work_management from '@/src/Work_management/index.vue'
import Revenue_management from '@/src/Revenue_management/index.vue'
import Expenditure_management from '@/src/Expenditure_management/index.vue'
import Business_report from '@/src/Business_report/index.vue'
import Operations from '@/src/Operations/index.vue'
//银行管理
import Account_details from '@/src/Bank_management/Account_details/index.vue'
import Account_list from '@/src/Bank_management/Account_list/index.vue'
import monetary_management from '@/src/Bank_management/monetary_management/index.vue'
import Transfer_details from '@/src/Bank_management/Transfer_details/index.vue'

//用户帐号

import Account_management from '@/src/User_account/Account_management/index.vue'
import theoretical_price from '@/src/User_account/theoretical_price/index.vue'




//基础资料  //公司相关  收入类别
import Income_category from '@/src/basic_data/Company_related/Income_category/index.vue'
import Settlement_department from '@/src/basic_data/Company_related/Settlement_department/index.vue'


 ////基础资料  //项目相关Project_related
import Affiliated_company from '@/src/basic_data/Project_related/Affiliated_company/index.vue'
import Customer_type from '@/src/basic_data/Project_related/Customer_type/index.vue'
import Department from '@/src/basic_data/Project_related/Department/index.vue'


// 工资管理
import Monthly_salary from '@/src/salary_management/Monthly_salary/index.vue'
import Annual_salary from '@/src/salary_management/Annual_salary/index.vue'
import Annual_department from '@/src/salary_management/Annual_department/index.vue'
import Monthly_department from '@/src/salary_management/Monthly_department/index.vue'



//评图
import Design_comment from '@/src/design_comment/index.vue'

import login from '../../src/login/index.vue'

Vue.use(Router)

export default new Router({
    mode: 'history' , //将hash  模式改变成history 模式 去除掉地址栏的#号,

  routes: [
    {
      path: "/",
      name: "index",
      component: home,

    },
     {
        path: "/login",
        name: "登录页",
        component: login
      },
    {
        path: "/Staff_management",
        name: "员工管理",
        component: Staff_management
      },
      {
        path: "/Customer_management",
        name: "客户管理",
        component: Customer_management
      },
       {
        path: "/Work_management",
        name: "作品管理",
        component: Work_management
      },
      {
        path: "/Revenue_management",
        name: "收入管理",
        component: Revenue_management
      },
      {
        path: "/Expenditure_management",
        name: "支出管理",
        component: Expenditure_management
      },
      {
        path: "/Business_report",
        name: "业务报表",
        component: Business_report
      },
      {
        path: "/Operations",
        name: "运营情况",
        component: Operations
      },
      {
        path: "/Account_details",
        name: "账户明细",
        component: Account_details
      },
      {
        path: "/Account_list",
        name: "账户列表",
        component: Account_list
      },
      {
        path: "/monetary_management",
        name: "货币管理",
        component: monetary_management
      },
      {
        path: "/Transfer_details",
        name: "转移明细",
        component: Transfer_details
      },
        {
        path: "/Account_management",
        name: "帐号管理",
        component: Account_management
      },
        {
        path: "/theoretical_price",
        name: "理论价格设置",
        component: theoretical_price
      },
        {
        path: "/Income_category",
        name: "收入类别",
        component: Income_category
      },
        {
        path: "/Settlement_department",
        name: "结算部门",
        component: Settlement_department
      },{
        path: "/Affiliated_company",
        name: "客户类型",
        component: Affiliated_company
      },{
        path: "/Customer_type",
        name: "所属公司",
        component: Customer_type
      }
      ,{
        path: "/Department",
        name: "所属部门",
        component: Department
      }
      ,{
        path: "/Monthly_salary",
        name: "员工每月工资表",
        component: Monthly_salary
      },
      {
        path: "/Annual_salary",
        name: "员工年度工资表",
        component: Annual_salary
      },
      {
        path: "/Annual_department",
        name: "部门年度成本表",
        component: Annual_department
      },
      {
        path: "/Monthly_department",
        name: "每月部门产值成本",
        component: Monthly_department
      },
      {
        path: "/Design_comment",
        name: "评图",
        component: Design_comment
      }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js